import { z } from "zod";
import {
  CompanyEnrichmentRequestIdPublicSchema,
  UserEnrichmentRequestIdPublicSchema,
} from "./branded-id.schemas.js";
import { EnrichedUserDataViewSchema } from "./enriched-user-data-admin.schemas.js";
import { EnrichedCompanyViewSchema } from "./enriched-company-admin.schemas.js";

/**
 * One participant's enrichment as the admin sees it: the requests that produced
 * it (public ids only — the request entities carry `correlationId`, a Clay
 * round-trip secret that must not leak) plus the enriched user/company records
 * projected to their secret-free views. A participant fans out to every company
 * across its employment history, so companies — and the requests behind them —
 * surface as plural sets rather than a single latest record.
 *
 * Shared by every admin surface that shows a participant's enrichment; it
 * belongs to no single feature.
 */
export const AdminParticipantEnrichmentSchema = z.object({
  userRequestIdPublic: UserEnrichmentRequestIdPublicSchema.nullable(),
  companyRequestIdsPublic: z.array(CompanyEnrichmentRequestIdPublicSchema),
  enrichedUserData: EnrichedUserDataViewSchema.nullable(),
  enrichedCompanies: z.array(EnrichedCompanyViewSchema),
});

export type AdminParticipantEnrichment = z.infer<
  typeof AdminParticipantEnrichmentSchema
>;
